import * as React from 'react'
import map from 'lodash/map'

import {type DetailedSchoolT} from '@frontrow/console/src/models/school'
import {
  rowWrapper,
  schoolNameWrapper,
  inputWrapper,
  headerRow
} from './editable-rp-identifier-table.module.scss'

type Props = {
  schools: Array<DetailedSchoolT>
  schoolsRpIdentifierMap: {
    [schoolId: string]: string
  }
  onUpdateRpIdentifier: (schoolId: number, rpIdentifier?: string | null) => void
}

export function EditableRpIdentifierTable(props: Props): React.ReactElement {
  const {schools, schoolsRpIdentifierMap, onUpdateRpIdentifier} = props

  return (
    <div>
      <div className={`flex ${rowWrapper} ${headerRow}`}>
        <span className={schoolNameWrapper}>
          <strong>SCHOOL</strong>
        </span>
        <span className={inputWrapper}>
          <strong>RP IDENTIFIER (SCHOOL GUID)</strong>
        </span>
      </div>
      {map(schools, school => (
        <div className={`flex ${rowWrapper}`} key={school.id}>
          <span className={schoolNameWrapper}>{school.name}</span>
          <input
            className={inputWrapper}
            value={schoolsRpIdentifierMap[school.id.toString()]}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              onUpdateRpIdentifier(school.id, e.currentTarget.value)
            }
          />
        </div>
      ))}
    </div>
  )
}
